<template lang="pug">
  div
    yz-skeleton-loader(type="article")
    yz-skeleton-loader.mt-4(type="card")
    yz-skeleton-loader.mt-4(type="article")
</template>

<script>
export default {
}
</script>

<style scoped></style>
